module.exports = __webpack_public_path__ + "img/公司简介政府支持.c7499379.png";